



import Vue from 'vue'

const DefaultLayout = 'logged-out';

export default Vue.extend({
    metaInfo: {
        // Default title that can be overridden once we know the page name
        title: 'SaaScada',
        // All titles will be injected into this template
        titleTemplate: '%s | SaaScada Portal'
    },
    computed: {
        layout() {
            const routeLayout = (this.$route.meta.layout || DefaultLayout);
            return `${routeLayout}-layout`;
        },
    },
});
